export default __webpack_public_path__ + "static/media/zomato.9c62c536.png";